export { default as AddPartPayment } from 'us.collection.partpayments/services/AddPartPayment/AddPartPayment';